class ScrollUtils {
  scrollToTop() {
    const centerContentContainer = this.#getContainer();
    centerContentContainer.scrollTo({ top: 0, behavior: "smooth" });
  }

  /**
   * Scrolls to an element with a smooth animation and optional top offset
   * @param {HTMLElement} element - The element to scroll to
   * @param {Object} opts - Options object
   * @param {number} opts.topOffset - Offset in pixels from the top (default: 16)
   */
  scrollToElement(element, opts) {
    const centerContentContainer = this.#getContainer();
    const containerRect = centerContentContainer.getBoundingClientRect();
    const elementRect = element.getBoundingClientRect();

    // Calculate the element's position relative to the container
    const elementTopRelativeToContainer = elementRect.top - containerRect.top + centerContentContainer.scrollTop;

    // Calculate target scroll position with offset
    const topOffset = opts?.topOffset ?? 16;
    const targetScrollTop = elementTopRelativeToContainer - topOffset;

    // Scroll smoothly to the calculated position
    centerContentContainer.scrollTo({
      top: Math.max(0, targetScrollTop),
      behavior: "smooth",
    });
  }

  #getContainer() {
    const container = document.getElementById("center-content-container");
    if (!container) {
      throw new Error("Center content container not found");
    }
    return container;
  }
}

const instance = new ScrollUtils();
window.scrollUtils = instance;
export default instance;
